module.exports = __webpack_public_path__ + "img/img-esfj.71ed3008.jpg";